
<div class="box-dash" style="margin:0px;">
  <div class="tpm-box-dash-hdr-bar">
    <h2 class="tpm-box-dash-hdr">Business Units</h2>
  </div>
  <div class="row talent-payroll">
    <div *ngFor="let businessUnit of businessUnits"
         class="col-xl-1 col-lg-1 col-md-2 col-sm-3 col-xs-4">
      <div (click)="onBusinessUnitSelected(businessUnit);"
           class="tpm-business-units">
        <div class="tpm-buttons-business-units"
             [ngClass]="{'tpm-business-unit-selected': businessUnit.id == selectedBusinessUnit.id}">
          <img style="height:auto;"
               [class.tpm-business-unit-img-5]="businessUnit.id =='5' ||null"
               [class.tpm-business-unit-img-1]="businessUnit.id =='1' ||null"               
               src="/Content/app/images/TalentPayrollBU/{{businessUnit.id}}.png" />
          <span class="tpm-buttons-business-units-Count"> {{businessUnit.inqueueTimecardsCount}}</span>
        </div>
      </div>
    </div>
  </div>
</div>

